import { COLORS } from 'colors';

export const customTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: COLORS.GRAY_800
  }
});

export const customStyles = {
  control: (provided, state) => {
    const selectedOption = state.selectProps.value;
    return {
      ...provided,
      maxWidth: 80,
      height: '25px',
      minHeight: '25px',
      padding: 0,
      background: selectedOption?.backgroundColor,
      borderRadius: '20px',
      border: '0px',
      textAlign: 'center'
    };
  },
  valueContainer: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    alignContent: 'center',
    height: '20px'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.775rem'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: COLORS.GRAY_800,
    borderRadius: '5px'
  }),
  option: (provided, state) => ({
    ...provided,
    padding: 7,
    backgroundColor: state.isFocused ? COLORS.OPTION_HOVER_BG : COLORS.GRAY_800,
    fontSize: '0.775rem'
  })
};
